import { MapPin, Phone, Mail, Clock } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHeader, CtaButton } from "@/components/Bits";
import { CONTACT, HOURS } from "@/data/catalog";

export default function Kontakt() {
  const mapSrc =
    "https://www.google.com/maps?q=Hauptplatz+36,+8480+Mureck,+Austria&output=embed";
  const mailtoBody =
    "mailto:" +
    CONTACT.email +
    "?subject=Anfrage%20%C3%BCber%20impexmiltrade.com&body=Guten%20Tag%2C%0A%0Aich%20interessiere%20mich%20f%C3%BCr%3A%0A%0A%0AMit%20freundlichen%20Gr%C3%BC%C3%9Fen%2C%0A";

  return (
    <>
      <Seo
        title="Kontakt & Anfrage"
        description="Kontaktieren Sie IMPEXMILTRADE GMBH — Hauptplatz 36, A-8480 Mureck. Telefon +43 664 140 22 45, office@impexmiltrade.com. Anfrage für Waffen, Munition und Zubehör."
      />
      <PageHeader
        code="KONTAKT / Anfrage stellen"
        title="Kontakt"
        sub="Sie haben eine Frage zu einer Waffe, benötigen Munition oder wünschen ein Angebot? Rufen Sie uns an oder schreiben Sie uns — wir melden uns umgehend."
      />

      <section className="mx-auto max-w-7xl px-5 py-16" data-testid="kontakt-grid">
        <div className="grid border border-border lg:grid-cols-[1fr_1fr]">
          {/* Details */}
          <div className="divide-y divide-border border-b border-border lg:border-b-0 lg:border-r">
            <a href={`tel:${CONTACT.phoneHref}`} className="flex items-start gap-4 p-6 transition-colors hover:bg-card md:p-8" data-testid="kontakt-phone">
              <Phone className="mt-1 shrink-0 text-primary" size={22} />
              <span>
                <span className="mono-label block text-muted-foreground">Telefon</span>
                <span className="mt-1 block font-display text-2xl font-500 uppercase tracking-tight text-foreground">{CONTACT.phone}</span>
              </span>
            </a>
            <a href={mailtoBody} className="flex items-start gap-4 p-6 transition-colors hover:bg-card md:p-8" data-testid="kontakt-email">
              <Mail className="mt-1 shrink-0 text-primary" size={22} />
              <span>
                <span className="mono-label block text-muted-foreground">E-Mail</span>
                <span className="mt-1 block font-mono-t text-lg text-foreground">{CONTACT.email}</span>
              </span>
            </a>
            <div className="flex items-start gap-4 p-6 md:p-8">
              <MapPin className="mt-1 shrink-0 text-primary" size={22} />
              <span>
                <span className="mono-label block text-muted-foreground">Adresse</span>
                <address className="mt-1 not-italic font-body text-lg text-foreground">
                  {CONTACT.name}
                  <br />
                  {CONTACT.street}, {CONTACT.city}
                  <br />
                  {CONTACT.country}
                </address>
              </span>
            </div>
            <div className="flex items-start gap-4 p-6 md:p-8">
              <Clock className="mt-1 shrink-0 text-primary" size={22} />
              <span className="w-full">
                <span className="mono-label block text-muted-foreground">Öffnungszeiten</span>
                <ul className="mt-3 divide-y divide-border border-t border-border">
                  {HOURS.map((h) => (
                    <li key={h.day} className="flex flex-col justify-between gap-1 py-3 sm:flex-row sm:items-center">
                      <span className="mono-label text-foreground">{h.day}</span>
                      <span className="font-body text-sm text-muted-foreground">{h.time}</span>
                    </li>
                  ))}
                </ul>
              </span>
            </div>
          </div>

          {/* Map + CTA */}
          <div className="flex flex-col">
            <div className="relative h-72 border-b border-border lg:h-auto lg:flex-1">
              <iframe
                title="Standort Impexmiltrade GmbH"
                src={mapSrc}
                className="h-full w-full grayscale"
                style={{ border: 0, minHeight: "260px" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="kontakt-map"
              />
            </div>
            <div className="p-8">
              <p className="mono-label text-primary">Direkt anfragen</p>
              <p className="mt-3 font-body text-muted-foreground">
                Am schnellsten erreichen Sie uns telefonisch. Für schriftliche Anfragen nutzen Sie bitte E-Mail.
              </p>
              <div className="mt-6 flex flex-wrap gap-4">
                <CtaButton href={mailtoBody} testid="kontakt-cta-mail">
                  E-Mail schreiben <Mail size={16} />
                </CtaButton>
                <CtaButton href={`tel:${CONTACT.phoneHref}`} variant="ghost" testid="kontakt-cta-phone">
                  Anrufen <Phone size={16} />
                </CtaButton>
              </div>
            </div>
          </div>
        </div>

        <p className="mono-label mt-6 text-muted-foreground">
          § Abgabe von Waffen und Munition erfolgt ausschließlich an berechtigte Personen nach österreichischem Waffengesetz.
        </p>
      </section>
    </>
  );
}
